













import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {Icon, Map, Marker, TileLayer} from 'leaflet'
import {GmapPosition, MapConfig} from '@/config/map.config'

@Component
export default class ItMap extends Vue {
  @Prop({type: Array, default: () => []}) markers!: GmapPosition[]
  @Prop({type: Object, required: true}) position!: GmapPosition
  @Prop({type: String, default: null}) title!: string | null
  @Prop({type: String}) innerClass?: string

  uid: string | null = null

  openInGoogleMaps() {
    const url = `https://www.google.com.br/maps/search/?api=1&query=${this.position.lat},${this.position.lng}`
    window.open(url, '_blank')
  }

  async mounted() {
    // @ts-ignore
    this.uid = this._uid

    await this.$nextTick()

    if (!(this.position.lat && this.position.lng)) return

    const [lat, lng] = [this.position.lat, this.position.lng]

    const map = new Map(`map${this.uid}`, {
      center: [lat, lng],
      zoom: 14,
      zoomControl: false,
    })

    new TileLayer(MapConfig.urlTemplate, MapConfig.tileLayerOptions).addTo(map)

    const CustomIcon = Icon.extend({
      options: {
        iconUrl: './img/itrack/simple-marker.svg',
        iconSize:     [24, 36],
        iconAnchor:   [10, 34],
        popupAnchor:  [-3, -76],
      },
    })

    for (const marker of this.markers) {
      const [lat, lng] = [marker.lat, marker.lng]
      new Marker([lat, lng], {icon: new CustomIcon()}).addTo(map)
    }
  }
}
